import React from 'react'

//* components
import Button from '../../../src/components/global/button'
import ContentRows from '../../../src/components/global/contentRows'
import Table from '../../../src/components/global/table'

//* utils
import { internalLinkHandler } from '../../../src/utils/link.utils'
import MODULE_MAPPING from '../../constants/contentIDs'

//* modules
import { dataFormatterRecursive } from '../dataFormatter'
import {
  getBio,
  getCustomerDetails,
  getIconLink,
  getQuote,
  getTopicCta,
  getWrapperImage,
  getWrapperVideo,
} from './modules'

export const embeddedEntry = (node: any) => {
  const { sys, fields } = node.data?.target
  const id = sys?.contentType?.sys?.id

  switch (id) {
    case MODULE_MAPPING.WRAPPER_ASSET:
      return getWrapperImage(fields)

    case MODULE_MAPPING.COMPONENT_QUOTE:
      return getQuote(fields)

    case MODULE_MAPPING.WRAPPER_VIDEO:
      return getWrapperVideo(fields)

    case MODULE_MAPPING.TOPIC_CUSTOMER_DETAIL:
      return getCustomerDetails(fields)

    case MODULE_MAPPING.COMPONENT_BIO:
      return getBio(fields)

    case MODULE_MAPPING.TOPIC_ANCHOR_LINK:
      return <span id={fields.identifier || ''}></span>

    case MODULE_MAPPING.COMPONENT_CONTENT_ROW:
      const formattedContentRows = dataFormatterRecursive(
        fields,
        MODULE_MAPPING.COMPONENT_CONTENT_ROW,
        id
      )
      return <ContentRows data={formattedContentRows} />

    case MODULE_MAPPING.TOPIC_CTA:
      return getTopicCta(fields)

    case MODULE_MAPPING.COMPONENT_TABLE:
      return <Table data={fields} />

    case MODULE_MAPPING.TOPIC_ICON_LINK:
      return getIconLink(fields)

    default:
      return null
  }
}

const renderLink = (node: any) => {
  const fields = node.data?.target?.fields
  const externalLink = fields?.externalUrl || ''
  const internalLink = fields?.internalLink ? internalLinkHandler(fields.internalLink) : ''
  const text = fields?.text || ''
  const link = externalLink || internalLink || ''

  if (link) {
    return (
      <div className="Inline-CTA-Container">
        <Button
          href={link}
          icon={true}
          text={text}
          type="inline-text-link"
          size="small"
          theme="light"
        />
      </div>
    )
  } else {
    return null
  }
}

export const inlineEmbeddedEntry = (node: any) => {
  const { sys, fields } = node.data?.target
  const id = sys?.contentType?.sys?.id

  switch (id) {
    case MODULE_MAPPING.TOPIC_CTA:
      return renderLink(node)

    case MODULE_MAPPING.WRAPPER_ASSET:
      return <div className="inline-entry">{getWrapperImage(fields)}</div>

    case MODULE_MAPPING.WRAPPER_VIDEO:
      return getWrapperVideo(fields)

    case MODULE_MAPPING.TOPIC_ANCHOR_LINK:
      return <span id={fields.identifier || ''}></span>

    default:
      return null
  }
}
